'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoverLink = require('../hover-link');

var _hoverLink2 = _interopRequireDefault(_hoverLink);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./tab-navigation.scss');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var STYLE_BASE = 'zk-tabNavigation_';

var TabNavigation = function (_Component) {
  _inherits(TabNavigation, _Component);

  function TabNavigation() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TabNavigation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TabNavigation.__proto__ || Object.getPrototypeOf(TabNavigation)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      activeTabIndex: _this.props.startingTabIndex || 0
    }, _this.handleOnClick = function (onClick, index) {
      if (onClick) {
        onClick(index);
      } else {
        _this.setState({
          activeTabIndex: index
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TabNavigation, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          controlledTabIndex = _props.controlledTabIndex,
          tabList = _props.tabList,
          tabClassName = _props.tabClassName;
      var activeTabIndex = this.state.activeTabIndex;
      var currentTabIndex = typeof controlledTabIndex !== 'undefined' ? controlledTabIndex : activeTabIndex;
      return _react2.default.createElement('div', {
        className: (0, _classnames2.default)(STYLE_BASE + 'tabWrapper', _defineProperty({}, className, !!className))
      }, _react2.default.createElement('div', {
        className: STYLE_BASE + 'tabRow'
      }, tabList.map(function (tab, index) {
        var _classNames2;

        return _react2.default.createElement(_hoverLink2.default, {
          testid: tab.testId,
          key: index,
          className: (0, _classnames2.default)(STYLE_BASE + 'tabStyle', (_classNames2 = {}, _defineProperty(_classNames2, STYLE_BASE + 'activeTabStyle', index === currentTabIndex), _defineProperty(_classNames2, tabClassName, !!tabClassName), _classNames2)),
          hoverClassName: STYLE_BASE + 'hoverStyle',
          text: tab.label,
          onPress: function onPress() {
            return _this2.handleOnClick(tab.onClick, index);
          }
        });
      })), tabList[currentTabIndex].tabComponent);
    }
  }]);

  return TabNavigation;
}(_react.Component);

TabNavigation.propTypes = {
  controlledTabIndex: _propTypes2.default.number,
  onClick: _propTypes2.default.func,
  startingTabIndex: _propTypes2.default.number,
  tabList: _propTypes2.default.array
};
exports.default = TabNavigation;